import { useEffect, useState } from "react";
import { themeColors } from "../../Components/theme";
import { connect } from "react-redux";
import { BsPencil } from "react-icons/bs";
import { FaSave } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import ShortLeadsRUbixLogo1 from '../../Assets/Images/shortLogoLeadsRubix1.png';
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import StyledCancelButton from "../../Components/Buttons/StyledCancelButton";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import InputTextValue from "../../Components/TextInput/InputTextValue";
import styles from "./MyProfile.module.css";
import { fetchUsersByAuthId, updateOrganization } from "../../Services/organizations";

const MyProfileAdmin = ({ user, theme }: any) => {
    const themeMUI = useTheme();
    const [editMode, setEditMode] = useState(false);
    const [orgUserId, setOrgUserId] = useState<string | null>(null);
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        contactNumber: "",
        email: "",
        profileStatus: "",
        country: "",
        state: "",
        contactCode: "",
        gst: ""
    });


    useEffect(() => {
        const authId = user?.auth_id;
        if (!authId) return;
        const unsubscribe = fetchUsersByAuthId(authId, (orgUser) => {
            setOrgUserId(orgUser.id);
            if (orgUser) {
                setForm({
                    firstName: orgUser.admin_first_name || "",
                    lastName: orgUser.admin_last_name || "",
                    contactNumber: orgUser.admin_contact_number || "",
                    email: orgUser.admin_email_id || "",
                    profileStatus: orgUser.profile || "Admin",
                    country: orgUser.country || "",
                    state: orgUser.state || "",
                    contactCode: orgUser.admin_contact_code || "",
                    gst: orgUser.GSTIN || ""
                });
            } else {
                console.warn("No organization found for this auth_id");
            }
        });
        return () => unsubscribe();
    }, [user?.auth_id]);

    const handleSave = async () => {
        if (!orgUserId) {
            console.error("Organization document ID missing");
            return;
        }

        await updateOrganization(orgUserId, form);
        setEditMode(false);
    };
    const handleCancel = () => {
        setEditMode(false);
    };

    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

    return (
        <Box className={styles.parent} style={{ marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
            <Box
                sx={{
                    minHeight: "calc(100vh - 60px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: isMobile ? 2 : 0,     // mobile padding
                    background: "transparent",
                    width: "100%",
                    fontFamily: "var(--font-family-main)",
                }}
            >
                <Box
                    sx={{
                        background: "linear-gradient(266deg, #rgb(168 171 210) 0%, #fffbe6 100%)",
                        borderRadius: 3,
                        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                        p: isMobile ? 2 : 5,     // responsive padding
                        maxWidth: 1100,
                        pb: isMobile ? 10 : 5, // extra bottom padding FIX ✔
                        width: "100%",
                        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
                        fontFamily: "var(--font-family, 'Roboto', sans-serif)",
                        position: "relative",
                    }}
                >

                    {/* Top Right Buttons */}
                    {!isMobile && (
                        <Box
                            sx={{
                                position: "absolute",
                                top: isMobile ? 10 : 20,
                                right: isMobile ? 10 : 20,
                                display: "flex",
                                gap: 1,
                            }}
                        >
                            {!editMode ? (
                                <StyledSubmitButton onClick={() => setEditMode(true)}>
                                    <BsPencil size={14} /> Edit
                                </StyledSubmitButton>
                            ) : (
                                <>
                                    <StyledSubmitButton onClick={handleSave}>
                                        <FaSave size={14} /> Save
                                    </StyledSubmitButton>
                                    <StyledCancelButton onClick={handleCancel}>
                                        <MdCancel size={14} /> Cancel
                                    </StyledCancelButton>
                                </>
                            )}
                        </Box>
                    )}

                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: isMobile ? 2 : 1,
                            textAlign: isMobile ? "center" : "left",
                            mb: 4,
                        }}
                    >
                        <Box
                            sx={{
                                height: isMobile ? 55 : 67,
                                width: isMobile ? 55 : 67,
                                borderRadius: "50%",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={ShortLeadsRUbixLogo1}
                                alt="logo"
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                }}
                            />
                        </Box>
                        <Box>
                            <Box sx={{ fontWeight: 700, fontSize: isMobile ? 18 : 22 }}>
                                {`${form.firstName} ${form.lastName}`.trim() || "Alexa Rawles"}
                            </Box>
                            <Box sx={{ color: "#888", fontSize: 14 }}>
                                {form.email || "alexarawles@gmail.com"}
                            </Box>
                        </Box>
                    </Box>

                    {/* 🟦 Responsive Grid Form */}
                    <Grid container spacing={2} sx={{ width: "100%" }}>
                        {/* Left Column */}
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="First Name"
                                value={form.firstName}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        firstName: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Last Name"
                                value={form.lastName}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        lastName: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Email"
                                value={form.email}
                                disabled
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        email: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Profile Status"
                                value={form.profileStatus}
                                disabled
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        profileStatus: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Contact Number"
                                value={form.contactNumber}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        contactNumber: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Country"
                                value={form.country}
                                disabled
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        country: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="State"
                                value={form.state}
                                disabled
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        state: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="GST"
                                value={form.gst}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        gst: e.target.value
                                    })
                                }
                            />
                        </Grid>
                    </Grid>

                    {/* Mobile Bottom Buttons - FIXED ✔ */}
                    {isMobile && (
                        <Box
                            sx={{
                                position: "absolute",
                                bottom: 16,
                                left: "50%",
                                transform: "translateX(-50%)",
                                display: "flex",
                                gap: 1,
                                zIndex: 30,
                            }}
                        >
                            {!editMode ? (
                                <StyledSubmitButton onClick={() => setEditMode(true)}>
                                    <BsPencil size={14} /> Edit
                                </StyledSubmitButton>
                            ) : (
                                <>
                                    <StyledSubmitButton onClick={handleSave}>
                                        <FaSave size={14} /> Save
                                    </StyledSubmitButton>
                                    <StyledCancelButton onClick={handleCancel}>
                                        <MdCancel size={14} /> Cancel
                                    </StyledCancelButton>
                                </>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        organizationUsers: state.organizationUsers.data,
        theme: state.theme.isLightMode,
        projectHeader: state.projectHeaderList.data,
        searchString: state.searchItem.projectSearchString,
    };
};

export default connect(mapStateToProps)(MyProfileAdmin);